import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

import Typo from '../../typography/typo/typo.jsx'
import Checkbox from '../../form/checkbox/checkbox.jsx'
import Input from '../../form/input/input.jsx'
import IconButton from '../../common/icon_button/icon_button.jsx'
import IntlMessage from '../../common/intl/intl_message.jsx'
import IntegrationQuickbook from '../../../setting/integration/integration_quickbook/integration_quickbook.jsx'
import { XeroIntegration } from '../../../setting/integration/xero/xero_integration'

class IntegrationForm extends Component {
  constructor (props) {
    super(props)

    this.state = {
      bInvoiceEmail: !!this.props.integration.invoiceEmail,
      bCostEmail: !!this.props.integration.costEmail,
      dataDate: null
    }

    this.data = {
      integration: _.cloneDeep(this.props.integration)
    }

    this._references = {
      inputInvoiceEmail: React.createRef(),
      inputCostEmail: React.createRef()
    }
  }

  static get propTypes () {
    return {
      integration: PropTypes.object,
      onSubmit: PropTypes.func,
      onError: PropTypes.func,
      quickbookApplicationName: PropTypes.string,
      quickbookConnectUrl: PropTypes.string,
      onDisconnectQuickbook: PropTypes.func,
      showQuickbookConnected: PropTypes.bool,
      showQuickbook: PropTypes.bool,
      showXero: PropTypes.bool
    }
  }

  static get defaultProps () {
    return {
      integration: null,
      onSubmit: null,
      onError: null,
      quickbookApplicationName: '',
      quickbookConnectUrl: '',
      onDisconnectQuickbook: null,
      showQuickbookConnected: false,
      showQuickbook: false,
      showXero: false
    }
  }

  componentDidMount () {
    document.body.addEventListener('keydown', this._onKeyDown)
  }

  componentWillUnmount () {
    document.body.removeEventListener('keydown', this._onKeyDown)
  }

  _onKeyDown = (ev) => {
    if (ev.keyCode === 13) {
      this._onFormSubmit(ev)
    }
  };

  render () {
    const integration = this.data.integration

    return (
      <div className='integration-form'>
        <div className='colleft'>
          <Typo className='profile'>
            <h2>
              <IntlMessage ident='setting.integration.contentTitle' />
            </h2>
            {this.props.showQuickbook ? (
              <div className='qb-content'>
                <p>
                  <IntlMessage
                    ident='setting.integration.contentInfoAlt1'
                    html
                  />
                </p>
                <p>
                  <IntlMessage
                    ident='setting.integration.contentInfoAlt2'
                    html
                  />
                </p>
                <p>
                  <IntlMessage
                    ident='setting.integration.contentInfoAlt3'
                    html
                  />
                </p>
              </div>
            ) : (
              <p>
                <IntlMessage ident='setting.integration.contentInfo' />
              </p>
            )}
          </Typo>
        </div>
        <div className='colright'>
          {this.props.showXero && <XeroIntegration />}
          {this.props.showQuickbook && (
            <IntegrationQuickbook
              title='setting.integration.quickbookTitle'
              applicationName={this.props.quickbookApplicationName}
              connectUrl={this.props.quickbookConnectUrl}
              onDisconnect={this.props.onDisconnectQuickbook}
              showConnected={this.props.showQuickbookConnected}
            />
          )}
          <form
            className='integrationform'
            method='post'
            noValidate
            action='#'
            onSubmit={this._onFormSubmit.bind(this)}
          >
            <div className='form-layout'>
              <div className='layoutcol'>
                <div className='formsection'>
                  <h3 className='title'>
                    <IntlMessage ident='setting.integration.mailToLabel' />
                  </h3>
                  {!this.props.showQuickbookConnected && (
                    <>
                      <div className='formrow formrow_alt'>
                        <div className='formcol'>
                          <Checkbox
                            label='setting.integration.formInvoiceTitle'
                            className='form-checkbox_alt'
                            checked={this.state.bInvoiceEmail}
                            icon='login'
                            onChange={this._onChangeCheckbox.bind(
                              this,
                              'bInvoiceEmail'
                            )}
                          />
                        </div>
                      </div>
                      <div className='formrow'>
                        <div className='formcol'>
                          <Input
                            type='text'
                            name='company'
                            maxLength={100}
                            label='setting.integration.formInvoiceInfo'
                            value={integration.invoiceEmail}
                            size={10}
                            ref={this._references.inputInvoiceEmail}
                            validations={['required', 'email']}
                            className={
                              !this.state.bInvoiceEmail ? 'disabled' : ''
                            }
                            onChange={this._onChangeInput.bind(
                              this,
                              'invoiceEmail'
                            )}
                          />
                        </div>
                      </div>
                    </>
                  )}
                  <div className='formrow formrow_alt'>
                    <div className='formcol'>
                      <Checkbox
                        label='setting.integration.formBookedCostsTitle'
                        className='form-checkbox_alt'
                        checked={this.state.bCostEmail}
                        icon='login'
                        onChange={this._onChangeCheckbox.bind(
                          this,
                          'bCostEmail'
                        )}
                      />
                    </div>
                  </div>
                  <div className='formrow'>
                    <div className='formcol'>
                      <Input
                        type='text'
                        name='company'
                        maxLength={100}
                        label='setting.integration.formBookedCostsInfo'
                        value={integration.costEmail}
                        size={10}
                        ref={this._references.inputCostEmail}
                        validations={['required', 'email']}
                        className={!this.state.bCostEmail ? 'disabled' : ''}
                        onChange={this._onChangeInput.bind(this, 'costEmail')}
                      />
                    </div>
                  </div>
                  <div className='formrow formrow_alt'>
                    <div className='formcol'>
                      <Checkbox
                        label='setting.integration.formExpensesTitle'
                        className='form-checkbox_alt'
                        checked={integration.isAttached}
                        icon='login'
                        onChange={this._onChangeInput.bind(this, 'isAttached')}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <IconButton
              icon='common-success-tick'
              title='setting.integration.tipSave'
              type='primary'
              size='big'
              canHover={false}
              className='wizard-submit'
              onClick={this._onFormSubmit.bind(this)}
            />
          </form>
        </div>
      </div>
    )
  }

  /* Event handlers */
  _onChangeCheckbox (name, bChecked) {
    this.setState({ [name]: bChecked })
    this._clearForm(name)
  }

  _onChangeInput (name, value) {
    this.data.integration[name] = value
    this.setState({ dataDate: new Date() })
  }

  /* Private Function */
  _onFormSubmit (ev) {
    ev.preventDefault()

    let noErrors = 0
    let field = ''
    if (
      this.state.bInvoiceEmail &&
      this._references.inputInvoiceEmail.current &&
      !this._references.inputInvoiceEmail.current.validate()
    ) {
      noErrors++
      field = 'setting.integration.msgInvoiceEmailError'
    } else if (
      this.state.bCostEmail &&
      this._references.inputCostEmail.current &&
      !this._references.inputCostEmail.current.validate()
    ) {
      noErrors++
      field = 'setting.integration.msgCostEmailError'
    }

    if (noErrors === 0) {
      if (this.props.onSubmit) {
        this.props.onSubmit(this.data.integration)
      }
    } else if (this.props.onError) {
      this.props.onError(field)
    }
  }

  _clearForm (name) {
    if (
      name === 'bInvoiceEmail' &&
      this.state.bInvoiceEmail &&
      this.data.integration &&
      this.data.integration.invoiceEmail
    ) {
      this.data.integration.invoiceEmail = ''
    } else if (
      name === 'bInvoiceEmail' &&
      !this.state.bInvoiceEmail &&
      !this.data.integration.invoiceEmail
    ) {
      if (this._references.inputInvoiceEmail.current) {
        this._references.inputInvoiceEmail.current.focus()
      }
    }

    if (
      name === 'bCostEmail' &&
      this.state.bCostEmail &&
      this.data.integration &&
      this.data.integration.costEmail
    ) {
      this.data.integration.costEmail = ''
    } else if (
      name === 'bCostEmail' &&
      !this.state.bCostEmail &&
      !this.data.integration.costEmail
    ) {
      if (this._references.inputCostEmail.current) {
        this._references.inputCostEmail.current.focus()
      }
    }
    this.setState({ dataDate: new Date() })
  }
}

export default IntegrationForm
